import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Typography,
  Button,
  Tabs,
  Tab,
  Stack,
  Dialog,
  Grid,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { listTags } from "../../../redux/slices/orgAdmin/tagsOrgSlice";
import { buildMedia } from "../../Utils/AuthService";
import { Select, MenuItem, InputLabel, FormControl, Chip } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { orderSectionData } from "../../../redux/slices/orgAdmin/promotionsSlice";
import CollectionsIcon from "@mui/icons-material/Collections";
import GalleryUpload from "./Utils/GalleryUpload";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import ReactQuill from "react-quill";
import AddIcon from "@mui/icons-material/Add";
import { fetchLanguages } from "../../../redux/slices/superAdmin/languagesSlice";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteSectionData } from "../../../redux/slices/orgAdmin/promotionsSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery, useTheme } from "@mui/material";
import FilterButton from "./Components/FilterButton";
import { Tooltip } from "@mui/material";
import { Flag } from "@mui/icons-material";
import { rowsPerPage } from "../../../Constants";
import { listDistricts } from "../../../redux/slices/orgAdmin/categoriesOrgSlice";
import Tags from "./Components/Tags";
import {
  StyledButton,
  StyledContainer,
  StyledTableCell,
} from "../../CSS/Styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  fetchNews,
  getNews,
  saveNews,
  updateNews,
} from "../../../redux/slices/orgAdmin/newsSlice";
import Attachments from "./Utils/Attachments";
import { fetchCategories } from "../../../redux/slices/orgAdmin/categoriesOrgSlice";
import { combineReducers } from "@reduxjs/toolkit";

export default function NewsLetterPolicyBriefs({
  formTitle,
  sectionType,
  sectionId,
}) {
  const dispatch = useDispatch();
  const { newsList, loading } = useSelector((state) => state.news);
  const { config } = useSelector((state) => state.app);
  const { languagesList } = useSelector((state) => state.languages);
  const { tags } = useSelector((state) => state.tags);
  const { categories } = useSelector((state) => state.categories);
  const { districts } = useSelector((state) => state.categoriesOrg);
  const { newsContent } = useSelector((state) => state.news);
  const { companyId } = useSelector((state) => state.app);
  const [localNews, setLocalNews] = useState([]);
  const [page, setPage] = useState(1);
  const totalRecords =
    newsContent?.pagination?.totalRecords || localNews.length;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);
  const [isEditing, setIsEditing] = useState(false);
  const [media, setMedia] = useState(null);

  const [isAddingNews, setIsAddingNews] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState("");
  const [defaultLanguage, setDefaultLanguage] = useState(null);

  const availableLanguages = languagesList?.map((lang) => lang.code);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isSorting, setIsSorting] = useState(false);
  const [deleteTitle, setDeleteTitle] = useState("");
  const [promotionIdToDelete, setPromotionIdToDelete] = useState(null);
  const [galleryDialogOpen, setGalleryDialogOpen] = useState(false);
  const [galleryId, setGalleryId] = useState(null);
  const [selectedFilterId, setSelectedFilterId] = useState(null);
  const [newNews, setNewNews] = useState({
    date: null,
    price: null,
    SEO: {
      en: { title: "", tag: "", description: "" },
      fr: { title: "", tag: "", description: "" },
      ar: { title: "", tag: "", description: "" },
    },
    en: { title: "", summary: "", description: "", district: "", city: "" },
    fr: { title: "", summary: "", description: "", district: "", city: "" },
    ar: { title: "", summary: "", description: "", district: "", city: "" },
    attachments: {
      mainImage: [],
      report: [],
    },
  });

  const [rowToEdit, setRowToEdit] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    dispatch(listTags({ companyId }));
  }, [dispatch, companyId]);

  useEffect(() => {
    dispatch(fetchCategories({ companyId, sectionId }));
    dispatch(fetchNews({ companyId, sectionType, page, limit: rowsPerPage }));
    if (!languagesList?.length) {
      dispatch(fetchLanguages());
    }
    setIsSorting(false);
  }, [dispatch, sectionType, sectionId, page]);

  useEffect(() => {
    if (newsContent?.data) {
      setLocalNews(newsContent.data);
    }
  }, [newsContent]);

  useEffect(() => {
    if (languagesList.length) {
      const defaultLang =
        languagesList.find(
          (lang) => lang.is_default === 1 || lang.is_default === "1"
        )?.code || "en";
      setCurrentLanguage(defaultLang);
      setDefaultLanguage(defaultLang);
    }
  }, [languagesList]);

  const [selectedCategoriesEDIT, setSelectedCategoriesEDIT] = useState();
  const [selectedDistrictEdit, setSelectedDistrictEDIT] = useState();

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const [selectedCategories, setSelectedCategories] = useState();
  const [selectedDistrict, setSelectedDistrict] = useState();

  const handleCategoryChange = (event) => {
    if (isEditing) {
      setSelectedCategoriesEDIT(event.target.value);
      setSelectedCategory(event.target.value.category_name);
    } else {
      setSelectedCategories(event.target.value);
    }
  };

  const handleDistrictChange = (event) => {
    if (isEditing) {
      setSelectedDistrictEDIT(event.target.value.name);
    } else {
      setSelectedDistrict(event.target.value);
    }
  };

  useEffect(() => {
    setRowToEdit(null);
    setSelectedCategories([]);
    setSelectedDistrict(null);
    setIsAddingNews(false);
  }, [sectionType]);

  useEffect(() => {
    dispatch(listDistricts());
  }, [sectionType]);

  const handleInputChange = (language, field, value, section = null) => {
    if (field === "date" || field === "price") {
      setNewNews((prev) => ({
        ...prev,
        [field]: value,
      }));
    } else if (section === "SEO") {
      setNewNews((prev) => ({
        ...prev,
        SEO: {
          ...prev.SEO,
          [language]: {
            ...prev.SEO[language],
            [field]: value,
          },
        },
      }));
    } else {
      setNewNews((prev) => ({
        ...prev,
        [language]: {
          ...prev[language],
          [field]: value,
        },
      }));
    }
  };

  const handleDeleteClick = (id, title) => {
    setPromotionIdToDelete(id);
    setDeleteDialogOpen(true);
    setDeleteTitle(title);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;

    // Reorder the items in local state
    const reorderedItems = Array.from(localNews);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    // Update local state for immediate UI feedback
    setLocalNews(reorderedItems);

    // Prepare the payload for dispatch with the reordered data
    const reorderedData = reorderedItems.map((item, index) => ({
      id: item.id,
      sortIndex: index + 1, // Assuming that you want to track the index for sorting
    }));

    // Dispatch the action to persist changes in the order
    dispatch(orderSectionData(reorderedData))
      .unwrap()
      .then(() => {
        dispatch(
          fetchNews({
            companyId,
            sectionType,
            page,
            limit: rowsPerPage,
            categoryId: selectedFilterId,
          })
        );
        setIsSorting(true);
      })
      .catch((error) => {
        console.error("Error updating order:", error);
      });
  };

  const handleDeleteMainImage = (isDeleted) => {
    setNewNews((prev) => ({
      ...prev,
      deleteMainImage: isDeleted, // ✅ Dynamically update promotionData
    }));
  };

  const handleDeleteAttachment = (language, attachmentId) => {
    setNewNews((prev) => {
      const updatedDeletedAttachments = new Set(prev.deletedAttachments || []);

      // Add language to the Set if an attachment was deleted
      updatedDeletedAttachments.add(language);

      return {
        ...prev,
        deletedAttachments: Array.from(updatedDeletedAttachments), // Convert Set back to Array
      };
    });
  };

  const confirmDelete = () => {
    dispatch(deleteSectionData({ id: promotionIdToDelete }))
      .then(() => {
        setDeleteDialogOpen(false);
        setPromotionIdToDelete(null);

        const updatedTotalRecords = Math.max(
          0,
          (newsList?.pagination?.totalRecords ?? newsList?.length ?? 0) - 1
        );
        const updatedTotalPages = Math.ceil(updatedTotalRecords / rowsPerPage);

        const newPage = Math.max(
          1,
          page > updatedTotalPages ? updatedTotalPages : page
        );

        setPage(newPage); // update local state, if needed

        dispatch(
          fetchNews({
            companyId,
            sectionType,
            page: newPage,
            limit: rowsPerPage,
          })
        );
      })
      .catch((error) => {
        console.error("Error deleting promotion:", error);
      });
  };

  const handleAddNews = () => {
    setSelectedTags([]);
    setIsEditing(false);
    setSelectedCategory(null);
    setSelectedCategories(null);
    setRowToEdit(null);
    setMedia(null);
    setNewNews({
      date: null,
      price: null,
      SEO: {
        en: { title: "", tag: "", description: "" },
        fr: { title: "", tag: "", description: "" },
        ar: { title: "", tag: "", description: "" },
      },
      en: {
        title: "",
        subtitle: "",
        summary: "",
        description: "",
        district: "",
        city: "",
      },
      fr: {
        title: "",
        subtitle: "",
        summary: "",
        description: "",
        district: "",
        city: "",
      },
      ar: {
        title: "",
        subtitle: "",
        summary: "",
        description: "",
        district: "",
        city: "",
      },
    });
    setCurrentLanguage(currentLanguage);
    setIsAddingNews(true);
  };

  const handleSaveLanguage = () => {
    if (currentLanguage === "ar") {
      handleExitAndSave();
    } else {
      setConfirmationDialogOpen(true);
    }
  };

  const handleAttachmentsChange = (newAttachments) => {
    setNewNews((prevNews) => {
      const prevAttachments = prevNews.attachments || {};

      return {
        ...prevNews,
        attachments: {
          ...prevAttachments,
          [`attachment_${currentLanguage}`]:
            newAttachments.report ??
            prevAttachments[`attachment_${currentLanguage}`],
          mainImage: newAttachments.hasOwnProperty("mainImage")
            ? newAttachments.mainImage
            : (prevAttachments.mainImage ?? null),
        },
      };
    });
  };

  const handleShowGallery = (id, title) => {
    setGalleryId(id);
    setGalleryDialogOpen(true);
    setDeleteTitle(title);
  };

  const handleEditNews = async (id) => {
    try {
      setRowToEdit(id);
      setIsEditing(true);
      const actualId = id && typeof id === "object" ? id.id : id;

      const newsData = await dispatch(
        getNews({ id: actualId, sectionType })
      ).then((res) => res.payload);

      if (
        newsData?.status === "error" &&
        newsData.message === "Record not found"
      ) {
        alert("Record not found.");
        return;
      }

      if (!newsData || !newsData.data) return;

      const extractSEO = (seoData) => {
        try {
          return seoData
            ? JSON.parse(seoData)
            : { title: "", tags: "", description: "" };
        } catch (error) {
          console.error("Error parsing SEO data:", error);
          return { title: "", tags: "", description: "" };
        }
      };

      const eventId = newsData.data?.id;
      const mainImage = newsData.data?.mainImage || "";

      const attachments = Object.keys(newsData.data)
        .filter(
          (lang) =>
            availableLanguages.includes(lang) && newsData.data[lang]?.attachment
        )
        .map((lang) => ({
          languageId: lang,
          fileName: newsData.data[lang].attachment,
        }));

      const mediaData = buildMedia(companyId, eventId, mainImage, attachments);
      setSelectedCategory(newsData.data[defaultLanguage]?.category_name);
      setSelectedCategoriesEDIT(newsData.data[defaultLanguage]?.fk_categoryId);
      setSelectedDistrictEDIT(newsData.data[defaultLanguage]?.district);

      const tag_ids = newsData.data?.[defaultLanguage]?.tag_ids || [];
      const tag_names = newsData.data?.[defaultLanguage]?.tag_names || [];

      const selectedTagsFromResponse = tag_ids.map((id, index) => ({
        id,
        tag_name: tag_names[index] || "",
      }));

      setSelectedTags(selectedTagsFromResponse);

      setMedia(mediaData);

      const prefilledEvent = {
        SEO: {
          en: extractSEO(newsData.data?.en?.SEO),
          fr: extractSEO(newsData.data?.fr?.SEO),
          ar: extractSEO(newsData.data?.ar?.SEO),
        },
        en: {
          title: newsData.data?.en?.title || "",
          subtitle: newsData.data?.en?.subtitle || "",
          summary: newsData.data?.en?.summary || "",
          description: newsData.data?.en?.description || "",
          district: newsData.data?.en?.district || "",
          city: newsData.data?.en?.city || "",
        },
        fr: {
          title: newsData.data?.fr?.title || "",
          subtitle: newsData.data?.fr?.subtitle || "",
          summary: newsData.data?.fr?.summary || "",
          description: newsData.data?.fr?.description || "",
          district: newsData.data?.fr?.district || "",
          city: newsData.data?.fr?.city || "",
        },
        ar: {
          title: newsData.data?.ar?.title || "",
          subtitle: newsData.data?.ar?.subtitle || "",
          summary: newsData.data?.ar?.summary || "",
          description: newsData.data?.ar?.description || "",
          district: newsData.data?.ar?.district || "",
          city: newsData.data?.ar?.city || "",
        },
        date: newsData.data?.[currentLanguage].date
          ? newsData.data[currentLanguage].date.replace(" ", "T").slice(0, 16)
          : "",
        price: newsData.data[currentLanguage]?.price || null,
        id: newsData.data?.id || null,
        attachments: {
          mainImage: newsData.data?.mainImage || null,
          report: newsData.data?.attachments?.report || [],
        },
        deleteMainImage: false,
        deletedAttachments: [],
      };

      setNewNews(prefilledEvent);
      setCurrentLanguage(currentLanguage);
      setIsAddingNews(true);
    } catch (error) {}
  };

  const handleProceedToNextLanguage = () => {
    setConfirmationDialogOpen(false);

    if (currentLanguage === "en") {
      setCurrentLanguage("fr");
    } else if (currentLanguage === "fr") {
      setCurrentLanguage("ar");
    }
  };

  const handleFinalizeNews = (closeForm = true) => {
    const payload = rowToEdit
      ? { id: typeof rowToEdit === "object" ? rowToEdit.id : rowToEdit }
      : {};

    const files = {};
    let hasValidLanguageData = false;

    const selectedTagIds = selectedTags?.map((tag) => tag.id);

    Object.entries(newNews).forEach(([lang, data]) => {
      if (availableLanguages.includes(lang)) {
        const hasData =
          data.title?.trim() ||
          data.subtitle?.trim() ||
          data.summary?.trim() ||
          data.description?.trim();

        if (hasData) {
          hasValidLanguageData = true;
          payload[lang] = {
            selectedTags: selectedTagIds,
            fk_categoryId:
              isEditing && selectedCategoriesEDIT
                ? selectedCategoriesEDIT.id || selectedCategoriesEDIT
                : selectedCategories?.id || null,
            title: data.title || "",
            subtitle: data.subtitle || "",
            summary: data.summary || "",
            description: data.description || "",
            district:
              isEditing && selectedDistrictEdit
                ? selectedDistrictEdit
                : selectedDistrict?.name || null,
            city: data.city || "",
            price: newNews.price || null,
            date: newNews.date || null,
            SEO: {
              title: newNews.SEO?.[lang]?.title || "",
              tags: newNews.SEO?.[lang]?.tags || "",
              description: newNews.SEO?.[lang]?.description || "",
            },
          };
        }
      }
    });

    // ✅ Throw an error if no language has valid data
    if (!hasValidLanguageData) {
      alert("Please fill at least one language field before finalizing."); // You can replace this with a UI error message
      return;
    }

    // Handle file attachments only for present languages
    if (newNews?.attachments?.mainImage?.length) {
      files["mainImage"] = newNews.attachments.mainImage[0].file;
    }

    Object.keys(payload).forEach((lang) => {
      if (newNews.attachments?.[`attachment_${lang}`]?.length) {
        files[`attachment_${lang}`] =
          newNews.attachments[`attachment_${lang}`][0].file;
      }
    });

    if (rowToEdit && newNews.deleteMainImage) {
      payload.deleteMainImage = true;
    }

    if (rowToEdit && newNews.deletedAttachments?.length > 0) {
      payload.deletedAttachments = newNews.deletedAttachments;
    }

    // ✅ Proceed only if we have valid data
    dispatch(saveNews({ payload, sectionId, files })).then(() => {
      dispatch(fetchNews({ companyId, sectionType, page, limit: rowsPerPage }));
    });

    setSelectedCategories([]);
    setRowToEdit(null);

    setNewNews({
      date: null,
      price: null,
      SEO: {
        en: { title: "", tag: "", description: "" },
        fr: { title: "", tag: "", description: "" },
        ar: { title: "", tag: "", description: "" },
      },
      en: {
        title: "",
        subtitle: "",
        summary: "",
        description: "",
        district: "",
        city: "",
      },
      fr: {
        title: "",
        subtitle: "",
        summary: "",
        description: "",
        district: "",
        city: "",
      },
      ar: {
        title: "",
        subtitle: "",
        summary: "",
        description: "",
        district: "",
        city: "",
      },
    });

    if (closeForm) {
      setIsAddingNews(false);
    }
  };

  const handleExitAndSave = () => {
    handleFinalizeNews();
    setConfirmationDialogOpen(false);
  };

  const handleFilterChange = (selectedOption) => {
    setSelectedFilterId(selectedOption.id);
    setIsSorting(true);
    dispatch(
      fetchNews({
        companyId,
        sectionType,
        page,
        limit: rowsPerPage,
        categoryId: selectedOption.id,
      })
    );
  };

  const languageChips = Object.fromEntries(
    languagesList.map((lang) => [
      lang.id,
      { name: lang.name, label: lang.code.toUpperCase(), color: "success" },
    ])
  );

  const formatToLocalDate = (dateString) => {
    const date = new Date(dateString);
    const offset = date.getTimezoneOffset() * 60000;
    return new Date(date - offset).toISOString().split("T")[0];
  };

  return (
    <StyledContainer>
      <Paper elevation={3} sx={{ padding: 3 }}>
        {!isAddingNews && (
          <>
            <Typography variant="h5" sx={{ mb: 2 }}>
              {formTitle}
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                >
                  <StyledButton
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={handleAddNews}
                    sx={{ marginBottom: 2 }}
                    disabled={loading}
                  >
                    Add
                  </StyledButton>

                  <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                    <TextField
                      type="number"
                      label="Edit by ID"
                      variant="outlined"
                      value={rowToEdit}
                      onChange={(e) => setRowToEdit(e.target.value)}
                      size="small"
                      sx={{ marginRight: 1 }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleEditNews(parseInt(rowToEdit))}
                      disabled={loading || !rowToEdit}
                    >
                      Edit
                    </Button>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <FilterButton
                  options={categories?.map((category) => ({
                    label: category.category_name,
                    id: category.id,
                  }))}
                  onFilterChange={handleFilterChange}
                  loading={loading}
                />
              </Grid>
            </Grid>
            <TableContainer component={Paper}>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="newsTable">
                  {(provided) => (
                    <Table ref={provided.innerRef} {...provided.droppableProps}>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width="5%"></StyledTableCell>
                          <StyledTableCell
                            width={languagesList.length >= 2 ? "65%" : "80%"}
                          >
                            Title
                          </StyledTableCell>
                          {languagesList.length >= 2 && (
                            <StyledTableCell width="15%">
                              Languages
                            </StyledTableCell>
                          )}
                          <StyledTableCell width="15%">Actions</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(newsContent?.data || []).map((item, index) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id.toString()}
                            index={index}
                            isDragDisabled={!isSorting}
                          >
                            {(provided, snapshot) => (
                              <TableRow
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  backgroundColor: snapshot.isDragging
                                    ? "#f5f5f5"
                                    : "inherit",
                                }}
                              >
                                {/* Drag Handle with Tooltip */}
                                <TableCell {...provided.dragHandleProps}>
                                  <Tooltip
                                    title={
                                      isSorting
                                        ? ""
                                        : "You can only sort when filtering"
                                    }
                                  >
                                    <span>
                                      <DragIndicatorIcon
                                        style={{
                                          cursor: !isSorting
                                            ? "not-allowed"
                                            : "grab",
                                          opacity: !isSorting ? 0.5 : 1,
                                        }}
                                      />
                                    </span>
                                  </Tooltip>
                                </TableCell>

                                {/* Title */}
                                <TableCell>{item.title || "N/A"}</TableCell>

                                {/* Languages Column - Chips */}
                                {languagesList.length >= 2 && (
                                  <TableCell>
                                    <Stack direction="row" spacing={1}>
                                      {Object.entries(languageChips).map(
                                        ([id, { name, label, color }]) => {
                                          const isActive =
                                            item.availableLanguages.includes(
                                              id
                                            );
                                          return (
                                            <Tooltip key={id} title={name}>
                                              <Chip
                                                label={label}
                                                color={
                                                  isActive ? color : "default"
                                                }
                                                variant={
                                                  isActive
                                                    ? "filled"
                                                    : "outlined"
                                                }
                                                style={{
                                                  opacity: isActive ? 1 : 0.5,
                                                }}
                                              />
                                            </Tooltip>
                                          );
                                        }
                                      )}
                                    </Stack>
                                  </TableCell>
                                )}

                                {/* Actions */}
                                <TableCell>
                                  <IconButton
                                    onClick={() => handleEditNews(item)}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                  <IconButton
                                    onClick={() =>
                                      handleDeleteClick(item.id, item.title)
                                    }
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                  <IconButton
                                    onClick={() =>
                                      handleShowGallery(item.id, item.title)
                                    }
                                  >
                                    <CollectionsIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    </Table>
                  )}
                </Droppable>
              </DragDropContext>
            </TableContainer>
            <Box mt={2} display="flex" justifyContent="center">
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size="large"
              />
            </Box>
          </>
        )}

        {isAddingNews && (
          <Box>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <IconButton onClick={() => setIsAddingNews(false)}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6">{formTitle}</Typography>
            </Box>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Category</InputLabel>
              <Select
                value={isEditing ? selectedCategory : selectedCategories || ""}
                onChange={handleCategoryChange}
                renderValue={(selected) =>
                  selected ? (
                    <Chip
                      key={isEditing ? selected : selected.id}
                      label={isEditing ? selected : selected.category_name}
                    />
                  ) : (
                    ""
                  )
                }
              >
                {categories?.map((category) => (
                  <MenuItem key={category.id} value={category}>
                    {category.category_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Tags
              tags={tags}
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
            />
            {languagesList?.length > 1 && (
              <Tabs
                value={currentLanguage}
                indicatorColor="primary"
                textColor="primary"
                onChange={(e, newValue) => setCurrentLanguage(newValue)}
              >
                {languagesList?.map((lang) => (
                  <Tab key={lang.code} value={lang.code} label={lang.name} />
                ))}
              </Tabs>
            )}
            <Box
              sx={{
                padding: 3,
                backgroundColor: "#f9f9f9",
                borderRadius: 2,
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Accordion
                defaultExpanded
                sx={{
                  marginBottom: 2,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#353634" }} />}
                >
                  <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                    General Information
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ height: !isMobile ? "600px" : "auto" }}>
                  <TextField
                    label="Title"
                    value={newNews[currentLanguage]?.title || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "title",
                        e.target.value
                      )
                    }
                    fullWidth
                  />

                  <TextField
                    sx={{ mt: 2 }}
                    label="Sub-Title"
                    value={newNews[currentLanguage]?.subtitle || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "subtitle",
                        e.target.value
                      )
                    }
                    fullWidth
                  />

                  <TextField
                    sx={{ mt: 2 }}
                    type="date"
                    label="Date"
                    InputLabelProps={{ shrink: true }}
                    value={newNews?.date ? formatToLocalDate(newNews.date) : ""} // Convert correctly
                    onChange={(e) =>
                      handleInputChange(null, "date", e.target.value)
                    }
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.target.showPicker();
                    }}
                    fullWidth
                  />
                  <ReactQuill
                    key={currentLanguage}
                    style={{
                      marginTop: "20px",
                      height: !isMobile ? "300px" : "auto",
                    }}
                    value={newNews[currentLanguage]?.description || ""}
                    onChange={(value) =>
                      handleInputChange(currentLanguage, "description", value)
                    }
                    theme="snow"
                    placeholder="Description..."
                    modules={{
                      toolbar: [
                        [{ header: "1" }, { header: "2" }, { font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        [{ align: [] }],
                        ["link"],
                        [{ color: [] }, { background: [] }],
                        ["clean"],
                      ],
                    }}
                  />
                </AccordionDetails>
              </Accordion>

              {config?.showPrice_Summary && (
                <Accordion
                  sx={{
                    marginBottom: 2,
                    border: "1px solid #ddd",
                    borderRadius: 2,
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#353634" }} />}
                  >
                    <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                      Price & Summary
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ height: !isMobile ? "450px" : "auto" }}
                  >
                    <ReactQuill
                      key={currentLanguage}
                      style={{
                        marginTop: "0px",
                        height: !isMobile ? "300px" : "auto",
                      }}
                      value={newNews[currentLanguage]?.summary || ""}
                      onChange={(value) =>
                        handleInputChange(currentLanguage, "summary", value)
                      }
                      theme="snow"
                      placeholder="Summary..."
                      modules={{
                        toolbar: [
                          [{ header: "1" }, { header: "2" }, { font: [] }],
                          [{ list: "ordered" }, { list: "bullet" }],
                          ["bold", "italic", "underline"],
                          [{ align: [] }],
                          ["link"],
                          [{ color: [] }, { background: [] }],
                          ["clean"],
                        ],
                      }}
                    />
                    <TextField
                      type="number"
                      label="Price"
                      fullWidth
                      variant="outlined"
                      sx={{ mt: 7 }}
                      value={newNews?.price}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          handleInputChange(null, "price", value);
                        }
                      }}
                      inputProps={{ min: 0 }}
                    />
                  </AccordionDetails>
                </Accordion>
              )}
              {config?.showLocation && (
                <Accordion
                  defaultExpanded
                  sx={{
                    marginBottom: 2,
                    border: "1px solid #ddd",
                    borderRadius: 2,
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#353634" }} />}
                  >
                    <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                      Location
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                      <InputLabel>District</InputLabel>
                      <Select
                        value={
                          isEditing
                            ? selectedDistrictEdit
                            : selectedDistrict || ""
                        }
                        onChange={handleDistrictChange}
                        renderValue={(selected) =>
                          selected ? (
                            <Chip
                              key={
                                isEditing ? selectedDistrictEdit : selected.name
                              }
                              label={
                                isEditing ? selectedDistrictEdit : selected.name
                              }
                            />
                          ) : (
                            ""
                          )
                        }
                      >
                        {districts?.map((district) => (
                          <MenuItem key={district.id} value={district}>
                            {district.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                      <TextField
                        sx={{ mt: 2 }}
                        label="City"
                        value={newNews[currentLanguage]?.city || ""}
                        onChange={(e) =>
                          handleInputChange(
                            currentLanguage,
                            "city",
                            e.target.value
                          )
                        }
                        fullWidth
                      />
                    </FormControl>
                  </AccordionDetails>
                </Accordion>
              )}
              <Accordion
                sx={{
                  marginBottom: 2,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#353634" }} />}
                >
                  <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                    SEO
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TextField
                    sx={{ mt: 2 }}
                    label="SEO Title"
                    value={newNews.SEO[currentLanguage]?.title || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "title",
                        e.target.value,
                        "SEO"
                      )
                    }
                    fullWidth
                  />

                  <TextField
                    sx={{ mt: 2 }}
                    label="SEO Tag"
                    value={newNews.SEO[currentLanguage]?.tags || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "tags",
                        e.target.value,
                        "SEO"
                      )
                    }
                    fullWidth
                  />

                  <TextField
                    sx={{ mt: 2 }}
                    label="SEO Description"
                    multiline
                    rows={4}
                    value={newNews.SEO[currentLanguage]?.description || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "description",
                        e.target.value,
                        "SEO"
                      )
                    }
                    fullWidth
                  />
                </AccordionDetails>
              </Accordion>

              <Accordion
                sx={{
                  marginBottom: 2,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#353634" }} />}
                >
                  <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                    Attachments
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Attachments
                    onAttachmentsChange={handleAttachmentsChange}
                    media={media}
                    currentLanguage={currentLanguage}
                    onDeleteMainImage={handleDeleteMainImage} // Pass delete flag handler
                    onDeleteAttachment={handleDeleteAttachment} // Pass
                  />
                </AccordionDetails>
              </Accordion>
            </Box>
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button
                color="error"
                variant="contained"
                onClick={() => {
                  setIsAddingNews(false);
                  setRowToEdit(null);
                }}
              >
                Cancel
              </Button>
              <Button
                sx={{ ml: 2 }}
                color="primary"
                variant="contained"
                onClick={handleSaveLanguage}
              >
                {languagesList?.length > 1 ? "SAVE OR SKIP" : "SAVE"}
              </Button>
            </Box>
          </Box>
        )}
        <GalleryUpload
          galleryDialogOpen={galleryDialogOpen}
          setGalleryDialogOpen={setGalleryDialogOpen}
          deleteTitle={deleteTitle}
          fk_sectionDataId={galleryId}
          companyId={companyId}
        />
        <Dialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete{" "}
              <span style={{ fontWeight: "bold" }}> {deleteTitle}</span>? This
              action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
            <Button color="error" onClick={confirmDelete}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={confirmationDialogOpen}
          onClose={() => setConfirmationDialogOpen(false)}
        >
          <DialogTitle>Proceed to Next Language?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you want to proceed to the next language or finalize this
              promotion?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleExitAndSave} color="primary">
              Exit And Save
            </Button>
            <Button onClick={handleProceedToNextLanguage} color="primary">
              Next Language
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </StyledContainer>
  );
}
